import { render, staticRenderFns } from "./SelectIconGrid.vue?vue&type=template&id=40bd913c&scoped=true&"
import script from "./SelectIconGrid.vue?vue&type=script&lang=js&"
export * from "./SelectIconGrid.vue?vue&type=script&lang=js&"
import style0 from "./SelectIconGrid.vue?vue&type=style&index=0&id=40bd913c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bd913c",
  null
  
)

export default component.exports